import { render, staticRenderFns } from "./BacTextarea.vue?vue&type=template&id=124d222c&scoped=true&"
import script from "./BacTextarea.vue?vue&type=script&lang=ts&"
export * from "./BacTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./BacTextarea.vue?vue&type=style&index=0&id=124d222c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d222c",
  null
  
)

export default component.exports